import { sha256 } from 'js-sha256'
import PAYMENT_METHODS from '@/constants/payment-methods'
import { TRACKING_EVENTS } from '@/constants/tracking'

const removeHtmlCodeInMessage = (message) => {
  if (!TypeChecker.isString(message)) {
    return ''
  }

  return message.replace(/(<[\w+\s-=":]+>)|(<\/[a-z]+>)/g, '')
}

const hashTextToSHA256 = (value) => (value ? sha256(value) : '')

const convertToYesNoValue = (value) => (value ? 'yes' : 'no')

const formatPaymentMethod = (value) =>
  ({
    [PAYMENT_METHODS.APPLE_PAY]: 'apple pay',
    [PAYMENT_METHODS.CREDIT_CARD]: 'credit card',
    [PAYMENT_METHODS.MADA_CARD]: 'mada card',
    [PAYMENT_METHODS.BANK_TRANSFER]: 'bank transfer',
  }[value] || '')

const setupTracking = (app) => {
  document.addEventListener('visibilitychange', () => {
    switch (document.visibilityState) {
      case 'hidden':
        {
          const eventName = TRACKING_EVENTS.CHECKOUT_PAGE_HIDDEN.EVENT_NAME
          const eventData = app.$trackingUtils.getTrackingData(eventName)
          app.$trackingService.TrackEvent(eventName, eventData)
        }
        break
      case 'visible':
        {
          const eventName = TRACKING_EVENTS.CHECKOUT_PAGE_VISIBLE.EVENT_NAME
          const eventData = app.$trackingUtils.getTrackingData(eventName)
          app.$trackingService.TrackEvent(eventName, eventData)
        }
        break
    }
  })
}

export {
  removeHtmlCodeInMessage,
  hashTextToSHA256,
  convertToYesNoValue,
  formatPaymentMethod,
  setupTracking,
}
